<template>
    <div>
        <div class="app-title">
            <em-view-title key="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <app-content class="content">
            <div class="card-body">
                <form>
                    <em-filter :entity="modelName" ref="emListFilter"
                               query-api="getTpmData"
                               $_em-custom-vuex-mixin_filter="spindleDataImageFilter"
                               :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                               :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                               @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                               @emFilterQueried="handleQueried"
                               @doClear="initFilter()"
                    ></em-filter>
                </form>
            </div>
            <common-chart class="w-100 h-70" :options="option"></common-chart>
        </app-content>
        <em-modal-entity-selector ref="emModalEntitySelector"/>
    </div>
</template>

<script>

import AppContent from "@/components/echarts-part/stuff/AppContent";
import emCommonListMixin from "@/mixin/em/common/list";
import CommonChart from "@/components/echarts-part/kpi/stuff/CommonChart";
import emCommonApiMixin from "@/mixin/em/common/api";
import moment from "moment";
import emCustomVuexMixin from "@/mixin/em/customVuex";

export default {
    name: "TpmSpindleDataTsdList",
    components: {AppContent, CommonChart},
    mixins: [emCommonListMixin, emCommonApiMixin, emCustomVuexMixin],
    data() {
        return {
            seriesData: [],
        }
    },
    mounted() {
        this.initFilter();
    },
    computed: {
        option() {
            return {
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    top: "20%",
                    left: '10%',
                    right: '10%',
                    bottom: '10%',
                    containLabel: true,
                },
                legend: {
                    data: ['主轴转速', '主轴负载']
                },
                xAxis: {
                    type: 'time',
                    boundaryGap: false,
                    axisLabel: {
                        formatter: function (value) {
                            return moment(value).format('YYYY-MM-DD HH:mm:ss');
                        }
                    },
                },
                yAxis: {
                    type: 'value'
                },
                dataZoom: [
                    {
                        type: 'slider',
                        start: 0,
                        end: 100,
                        xAxisIndex: 0
                    },
                    {
                        type: 'inside',
                        xAxisIndex: 0,
                    }
                ],
                series: this.seriesData
            };
        },
        modelName() {
            return 'sithMesTpmSpindleDataTsd'
        }
    },
    methods: {
        initFilter() {
            let currentDate = new Date();
            let queryEndDate = new Date();

            currentDate.setHours(0, 0, 0, 0);
            queryEndDate.setHours(23, 59, 59, 999);
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('tsdCollectTimeRteFilter', currentDate.getTime());
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('tsdCollectTimeLteFilter', queryEndDate.getTime());
        },
        handleQueried(response) {
            const opcRecords = response.data.opcRecords
            const workHours = response.data.workHours

            // 查询工时记录
            const markAreaData = [];
            if (workHours) {
                workHours.forEach(record => {
                    const item = [
                        {
                            name: '操作者：' + record.userName + '\n'
                                + '项目编号：' + record.projectCode + '\n'
                                + '工单编号：' + record.orderCode + '\n'
                                + '工序：' + record.prdPpOperationName + '\n'
                                + '上工时间: ' + record.startTime + '~' + record.endTime,
                            xAxis: record.startTime,
                            itemStyle: {
                                color: '#d4defc'
                            },
                        },
                        {
                            xAxis: record.endTime,
                        },
                    ]
                    markAreaData.push(item)
                })
            }

            // opc采集的数据
            const fieldNameMap = {
                tsdSpindleSpeed: "主轴转速",
                tsdSpindleLoad: "主轴负载"
            };
            const seriesData = []; // 折线数据
            if (opcRecords) {
                Object.keys(fieldNameMap).forEach(fieldName => {
                    const series = {
                        name: fieldNameMap[fieldName],
                        type: 'line',
                        symbol: 'none',
                        smooth: true,
                        sampling: 'lttb',//采用 Largest-Triangle-Three-Bucket 算法优化图表的绘制效率
                        data: opcRecords.map(item => [item.tsdCollectTime, item[fieldName]]),
                        markArea: {
                            label: {
                                show: false,
                            },
                            emphasis: {
                                label: {
                                    show: true,
                                    align: 'left',
                                    position: 'top',
                                    formatter: function (params) {
                                        return params.name;
                                    },
                                    textStyle: {
                                        color: '#2a2c30',
                                        fontSize: 12,
                                        lineHeight: 14
                                    }
                                }
                            },
                            data: markAreaData
                        },
                    };
                    seriesData.push(series);
                });
            }
            this.seriesData = seriesData
            console.log('seriesData--------', seriesData)
        }
    },
}
</script>

<style scoped>
.content {
    z-index: 1;
    background-color: white;
}

::v-deep .app-content {
    flex-direction: column !important;
}
</style>
